import { createFileRoute } from "@tanstack/react-router";
import { heritageCityRoute } from "@/lib/seo/heritageCityRoute";

export const Route = createFileRoute("/heritage/orebro")(
  heritageCityRoute({
    citySlug: "orebro",
    angle:
      "I Örebro och Bergslagen finns familjeföretag och verksamheter med lång historia där erfarenheten sällan finns nedskriven — samtidigt som många familjer vill bevara berättelser från en tid när regionen såg helt annorlunda ut.",
    localUseCases: [
      "Livsberättelse med förälder eller morförälder i Örebro",
      "Kunskapsarv i logistik- och handelsbolag",
      "Företagshistoria i verksamheter med rötter i Bergslagen",
      "Generationsskifte i ägarledda bolag",
      "Släkthistoria kopplad till bruksorter och landsbygd",
      "Minnesfilm till högtidsdag eller släktträff"
    ],
  }),
);
